$(document).on('turbo:load turbo:render', () => {

    $("#submitRegistration").prop("disabled", true)
    $("#signature").hide()
    $("#applySignature").on("click", () =>{
        $("#signature").show()
        $("#applySignature").hide()
        $("#submitRegistration").prop("disabled", false);

    })
    // $('.authorization-fields').find('input').each(function(){
    //     //your code here
    //     $(this).on("change", checkForValidInputs);
    //
    // });


});


// function checkForValidInputs() {
//     let isValid = true;
//     $(".authorization-fields").find("input").each(function () {
//         if ($(this).val() == ""){
//             isValid = false;
//         }
//
//     });
//
//    if (isValid && $("signature").is(":visible")){
//    };
// }